import { render, staticRenderFns } from "./AssetPlacement.vue?vue&type=template&id=7b8dd306&"
import script from "./AssetPlacement.vue?vue&type=script&lang=js&"
export * from "./AssetPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports